import o from "styled-components";
import e from "../Icons/Close.js";
import n from "../../utils/colors.js";
import { device as t } from "../../utils/device.js";
const m = o.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: stretch;
  padding: 32px 22px;
`, s = o.h3`
  margin: 0;
  margin-bottom: 20px;
  font-family: VIC;
  font-size: 1.125rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.21px;
  color: ${n.blueGrey};

  &:focus {
    outline: none;
  }
`, c = o.p`
  margin: 0;
  margin-bottom: 40px;
  font-family: VIC;
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.21px;
  color: ${n.blueGrey};
`, f = o.button`
  display: inline-block;
  margin-top: -16px;
  margin-left: auto;
  padding: 5px;
  background: none;
  border: none;

  &:hover {
    cursor: pointer;
  }
`, p = o(e)`
  width: 20px;
  height: 20px;
  color: ${n.blueGrey};
`, d = o.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media ${t.isMobile} {
    width: 100%;
    button {
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  @media ${t.isDesktop}, ${t.isTablet} {
    flex-direction: row-reverse;
    justify-content: flex-end;

    button {
      margin-left: 16px;
      &:last-child {
        margin-left: 0;
      }
    }
  }
`;
export {
  d as ActionsContainer,
  p as IconBox,
  f as IconContainer,
  c as ModalBody,
  s as ModalTitle,
  m as Wrapper
};
